// extracted by mini-css-extract-plugin
module.exports = {"blockLi":"_9PTIt","blockUl":"_3gopA"};